
import axios from "axios";
import "./loader.css";

function createLoader() {
  let loaderdiv = document.createElement("div");
  loaderdiv.classList.add("loaderdiv");
  let wrapper = document.createElement("div");
  wrapper.classList.add("wrapper");
  let circle = document.createElement("div");
  circle.classList.add("circle");
  let circle2 = circle.cloneNode(true);
  let circle3 = circle2.cloneNode(true);
  let shadow = document.createElement("div");
  shadow.classList.add("shadow");
  let shadow2 = shadow.cloneNode(true);
  let shadow3 = shadow2.cloneNode(true);
  let loader = document.createElement("span");
  loader.innerHTML = "Loading...";
  shadow.appendChild(loader);
  wrapper.appendChild(circle);
  wrapper.appendChild(circle2);
  wrapper.appendChild(circle3);
  wrapper.appendChild(shadow);
  wrapper.appendChild(shadow2);
  wrapper.appendChild(shadow3);
  wrapper.appendChild(loader);
  loaderdiv.appendChild(wrapper);
  return loaderdiv
}
export default async function ApiRequest(url, method, body, header, noloader = false) {
  let div;
  if (!noloader) {
    div = createLoader();
    document.body.appendChild(div);
  }
  const baseurl = "https://app.sparkstarns.com/mobile_app_api/";
  let obj = {
  }
  if (header) {
    obj.headers = header;
  }
  try {
    console.log(obj);
    let ApiRequest;
    if (method === "GET")
      ApiRequest = await axios.get(baseurl + url, obj);
    else
      ApiRequest = await axios.post(baseurl + url, body, obj);
    console.log(ApiRequest);
    if (ApiRequest.status !== 200) {
      return { status: "error", message: ApiRequest.statusText }
    }
    if (!noloader)
      document.body.removeChild(div);
    return ApiRequest.data;
  } catch (e) {
    console.log(e);
    if (!noloader)
      document.body.removeChild(div);
    return { status: "error", message: e.message };
  }
}